import { React, useEffect, useState } from 'react';
import { Row, Col, Button, Modal, Space, message, Checkbox, Form, Tag } from 'antd';
import { ExclamationCircleOutlined, HeartOutlined, PlusOutlined } from '@ant-design/icons';
import axios from "axios";
import NewTable from "./components/NewTable";
import TutionFeeDetailModal from './components/TuitionFeeDetailModal';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { useForm } from 'antd/es/form/Form';
const { confirm } = Modal;

const TuitionFeeDetail = () => {
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, set_loading] = useState(0);
    const [force_reload, set_force_reload] = useState(0)
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [editcard, setEditCard] = useState({});
    const [color, setColor] = useState('d65b77');
    const [messageApi, contextHolder] = message.useMessage();
    const [datas, setDatas] = useState([])
    const [default_column, set_default_column] = useState([
        {
            title: '代碼編號',
            key: 'iSerialID',
            dataIndex: 'iSerialID',
            align: 'center',
        },
        {
            title: '項目種類',
            key: 'typename',
            dataIndex: 'typename',
            align: 'center',
        },
        {
            title: '綁定課程',
            key: 'lesson_salary_table_formula',
            dataIndex: 'lesson_salary_table_formula',
            align: 'center',
            render: (text, record, index) => {
                return <Space direction='vertical'>
                    {text.map((value) => {
                        return <Tag color='cyan'>{value?.name ?? "-"}</Tag>
                    })}
                </Space>
            }
        },
        {
            title: '項目名稱',
            key: 'cName',
            dataIndex: 'cName',
            align: 'center',
        },

        {
            title: '適用時間與單價',
            key: 'FormulaRule_data',
            dataIndex: 'FormulaRule_data',
            align: 'center',
            render: (text, record, index) => {
                let FormulaRule_data = record?.FormulaRule_data ?? []
                let detail_data = FormulaRule_data.find((_) => { return true })
                let Salary_TABLE_FormulaRuleHistory_datas = detail_data?.Salary_TABLE_FormulaRuleHistory_data || []

                return <Space direction='vertical'>
                    <Tag color='gold'>
                        預設價格 {record?.iDefaultValue || 0} 元
                    </Tag>
                    {
                        Salary_TABLE_FormulaRuleHistory_datas.map((value) => {
                            return <Tag color='blue'>{value?.tActivationTime}起 {value?.fNumeric}元</Tag>
                        })
                    }
                </Space>
            }
        },
        {
            title: '計價單位',
            key: 'FormulaRule_data',
            dataIndex: 'FormulaRule_data',
            align: 'center',
            render: (text, record, index) => {
                let FormulaRule_data = record?.FormulaRule_data ?? []
                let detail_data = FormulaRule_data.find((_) => { return true })
                return detail_data?.cUnitName ?? '-'
            }
        },
        {
            title: '備註',
            key: 'tRemark',
            dataIndex: 'tRemark',
            align: 'center',
        },
        {
            title: '操作',
            align: 'center',
            sorter: false,
            render: (text, record, index) => {
                let FormulaRule_data = record?.FormulaRule_data ?? []
                let detail_data = FormulaRule_data.find((_) => { return true })
                let lesson_salary_table_formula = record?.lesson_salary_table_formula ?? []
                let lesson_id = lesson_salary_table_formula.map((value) => { return value?.lesson_id })
                let tActivationTime = record?.tActivationTime
                let Salary_TABLE_FormulaRuleHistory_datas = detail_data?.Salary_TABLE_FormulaRuleHistory_data || []
                let Salary_TABLE_FormulaRuleHistory_data = Salary_TABLE_FormulaRuleHistory_datas.map((value) => {
                    let thistActivationTime = value?.tActivationTime === null ? null : dayjs(value?.tActivationTime, "YYYY-MM-DD")
                    return {
                        ...value,
                        tActivationTime: thistActivationTime
                    }
                })
                let data = {
                    ...record,
                    lesson_id: lesson_id,
                    iRuleID: detail_data?.iRuleID || 0,
                    ...detail_data,
                    Salary_TABLE_FormulaRuleHistory_data,
                    tActivationTime: tActivationTime === null ? null : dayjs(record?.tActivationTime, "YYYY-MM-DD")
                }
                return <>
                    <Button type="text"
                        style={{ color: 'rgba(43, 193, 123, 1)' }}
                        onClick={e => {
                            setTitle('修改明細');
                            setColor('f09a45');
                            setEdit(true);
                            setOpen(true);
                            setEditCard(data)
                            form.setFieldsValue({
                                ...data,
                            })
                        }} >
                        編輯
                    </Button>
                    <Button
                        danger
                        type="text"
                        onClick={() => showMessage(record)}
                    >
                        刪除
                    </Button>
                </>
            }

        },
    ]);
    const [form] = Form.useForm();
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const get_datas = (param, sort, filter, checklist) => {
        set_loading(true);
        let today = dayjs().format("YYYY-MM-DD")
        axios
            .get(`/Salary/formula/dataLoad`, {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then((response) => {
                set_total(response.data.data.iRows)
                setDatas(response.data.data.aRows);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    useEffect(() => {
        get_datas()
    }, []);
    const handleOnAddRow = () => {
        setTitle('新增種類');
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({});
        form.resetFields()
    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length === 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            // const deleterow = [];
            let deleterow = datas.filter((element) => {
                return selectedRowKeys.includes(element?.iFormulaID)
            })
            let data = deleterow.map((value) => {
                return {
                    iFormulaID: value?.iFormulaID
                }
            })

            axios
                .delete(`/Salary/formula/dataSave`, {
                    data
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status === 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload()
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload()
                    }
                })
        }
    }
    const handleOnDelete = (value) => {

        let data = [{ iFormulaID: value?.iFormulaID }]
        axios
            .delete(`/Salary/formula/dataSave`, {
                data
            })
            .then((response) => {
                if (response.data.status == 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_datas();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_datas();
                }
            })
    }
    const handleEdit = (values) => {
        if (values?.iFormulaID === undefined) {
            values.iFormulaID = 1
        }
        if (values?.iSerialID === undefined) {
            values.iSerialID = '';
        }
        let temptActivationTime
        let tempfNumeric
        let lesson_salary_table_formula = values?.lesson_id.map((value) => {
            return {
                "amount": 0,
                "lesson_id": value,
                "last_edit_user": 215
            }
        })
        let Salary_TABLE_FormulaRuleHistory_data = values?.Salary_TABLE_FormulaRuleHistory_data
        Salary_TABLE_FormulaRuleHistory_data.sort((a, b) => {
            return new Date(a.tActivationTime) - new Date(b.tActivationTime);
        })
        Salary_TABLE_FormulaRuleHistory_data = Salary_TABLE_FormulaRuleHistory_data.map((history) => {
            temptActivationTime = dayjs(history?.tActivationTime).format("YYYY-MM-DD")
            tempfNumeric = history?.fNumeric
            if (history?.iFormulaRuleHistoryID) {
                return {
                    iRuleID: values?.iRuleID || 0,
                    "fNumeric": history?.fNumeric,
                    "iFormulaRuleHistoryID": history?.iFormulaRuleHistoryID,
                    "tActivationTime": dayjs(history?.tActivationTime).format("YYYY-MM-DD"),
                }
            }
            else {
                return {
                    iRuleID: values?.iRuleID || 0,
                    "fNumeric": history?.fNumeric,
                    "tActivationTime": dayjs(history?.tActivationTime).format("YYYY-MM-DD"),
                }
            }

        })
        let data = {
            "iFormulaID": values.iFormulaID,
            "cName": values?.cName,
            iDefaultValue: values?.iDefaultValue || 0,
            "iSign": '1',
            "iFormulaType": values?.iFormulaType,
            "iSerialID": values?.iSerialID,
            "tRemark": values?.tRemark,
            "FormulaRule_data": [
                {
                    iUnitID: values?.iUnitID,
                    "iRuleID": values?.iRuleID || 0,
                    "cOperator": "*",
                    "fNumeric": tempfNumeric,
                    Salary_TABLE_FormulaRuleHistory_data,
                }],
            tActivationTime: temptActivationTime,
            lesson_Salary_TABLE_Formula: lesson_salary_table_formula
        }

        axios
            .patch(`/Salary/formula/dataSave`,
                [data]
            )
            .then((response) => {
                if (response.data.status === 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: `${response.data.messag || "修改失敗"}`,
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    reload();
                }
            })
    }
    const handleSubmit = (values) => {
        if (values.iFormulaID === undefined) {
            values.iFormulaID = 0
        }
        let lesson_Salary_TABLE_Formula = values?.lesson_id.map((value) => {
            return {
                "amount": 0,
                "lesson_id": value,
                "last_edit_user": 215
            }
        })
        let temptActivationTime
        let tempfNumeric
        let Salary_TABLE_FormulaRuleHistory_data = values?.Salary_TABLE_FormulaRuleHistory_data
        Salary_TABLE_FormulaRuleHistory_data.sort((a, b) => {
            return new Date(a.tActivationTime) - new Date(b.tActivationTime);
        })
        Salary_TABLE_FormulaRuleHistory_data = Salary_TABLE_FormulaRuleHistory_data.map((history) => {
            temptActivationTime = dayjs(history?.tActivationTime).format("YYYY-MM-DD")
            tempfNumeric = history?.fNumeric
            if (history?.iFormulaRuleHistoryID) {
                return {
                    iRuleID: values?.iRuleID || 0,
                    "fNumeric": history?.fNumeric,
                    "iFormulaRuleHistoryID": history?.iFormulaRuleHistoryID,
                    "tActivationTime": dayjs(history?.tActivationTime).format("YYYY-MM-DD"),
                }
            }
            else {
                return {
                    iRuleID: values?.iRuleID || 0,
                    "fNumeric": history?.fNumeric,
                    "tActivationTime": dayjs(history?.tActivationTime).format("YYYY-MM-DD"),
                }
            }

        })
        let data = {
            "cName": values?.cName,
            "iSign": '1',
            "iFormulaType": values?.iFormulaType,
            iDefaultValue: values?.iDefaultValue || 0,
            "tRemark": values?.tRemark,
            "iSerialID": values?.iSerialID,
            "FormulaRule_data": [
                {
                    iUnitID: values?.iUnitID,
                    "iRuleID": values?.iRuleID,
                    "cOperator": "*",
                    "fNumeric": tempfNumeric,
                    Salary_TABLE_FormulaRuleHistory_data,

                }],
            lesson_Salary_TABLE_Formula: lesson_Salary_TABLE_Formula,
            tActivationTime: temptActivationTime,

        }
        axios
            .post(`/Salary/formula/dataSave`,
                [data]
            )
            .then((response) => {
                if (response.data?.status === 'failure') {
                    messageApi.open({
                        type: 'error',
                        content: `${response.data.message ?? "新增失敗"}`,
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    reload();
                }
            })
            .finally(() => {

            })

    }
    return (
        <>
            {contextHolder}
            <TutionFeeDetailModal
                open={open}
                setOpen={setOpen}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                form={form}
            />
            <Row gutter={[8, 16]}>
                <Col span={24}>
                    <NewTable
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'SalaryTypeList'}
                        force_reload={force_reload}
                        columns={default_column.concat(extra_columns || [])}
                        getData={get_datas}
                        datas={datas}
                        other={false}
                        add_button_title={'新增種類'}//新增按鈕上的名稱
                        handleOnAddRow={handleOnAddRow}//新增row 內容
                        rowkey={'iFormulaID'}//key
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                    ></NewTable>
                </Col>
            </Row>
        </>
    )
}
export default TuitionFeeDetail;